import { render, staticRenderFns } from "./businessType.vue?vue&type=template&id=696e9b84&scoped=true"
import script from "./businessType.vue?vue&type=script&lang=js"
export * from "./businessType.vue?vue&type=script&lang=js"
import style0 from "./businessType.vue?vue&type=style&index=0&id=696e9b84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "696e9b84",
  null
  
)

export default component.exports